import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

/** AI sparkle icon — matches portal AI branding */
export const AIAssistantIcon: React.FC<{ size?: number | string; sx?: object }> = ({
  size = 24,
  sx,
}) => (
  <AutoAwesomeIcon
    aria-hidden
    sx={{
      fontSize: size,
      flexShrink: 0,
      display: 'block',
      background: 'linear-gradient(135deg, #6366F1 0%, #A855F7 100%)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      ...sx,
    }}
  />
);
